import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  title: {
    margin: 0,
    fontSize: "12px",
    fontWeight: 400,
    color: "#7A7A7A",
  },
  subtitle: {
    margin: "5px 0px 0px 0px",
    fontSize: "14px",
    fontWeight: 600,
    color: "#3D3D3D",
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "202px",
  },
  detailContainer: {},
}));
